<div class="my_order_details my_order_sec">
  <h2 class="heading">Order Details</h2>
  <div class="order_main" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
    <div class="column order_one" fxFlex.xl="70" fxFlex.lg="70" fxFlex.md="70" fxFlex.sm="70" fxFlex.xs="100"
      fxFlexFill>
      <div class="order_details_left">
        <!-- order_box -->
        <div class="order_box orders_boxs">
          <div class="order_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
            fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
            <div class="column order_col" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100"
              fxFlex.xs="100" fxFlexFill>
              <div class="order_flex">
                <div>
                  <h4 class="primary">Order Id : {{oldSupplyOrder.order_number}}</h4>
                  <p class="order_date">Order at : {{oldSupplyOrder.created_at | date: 'dd/MM/yyyy'}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="address_row_box">
            <div class="shipping_data" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
              fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start start" fxLayoutGap="25px">
              <div class="column shipping_data_col mobile_mb_0" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50"
                fxFlex.xs="100" fxFlexFill>
                <div class="address_box">
                  <h4>Shipping address :</h4>
                  <div class="media">
                    <div class="media-left">
                      <img src="../../../../../assets/images/icons/address.jpg" alt="">
                    </div>
                    <div class="media-body">
                      <p *ngIf="oldSupplyOrder?.billing_address?.short_name">{{oldSupplyOrder?.billing_address?.short_name}},</p>
                      <p *ngIf="oldSupplyOrder?.billing_address?.line_1">{{oldSupplyOrder?.billing_address?.line_1}},</p>
                      <p *ngIf="oldSupplyOrder?.billing_address?.line_2 && oldSupplyOrder?.billing_address?.landmark">
                        {{oldSupplyOrder?.billing_address?.line_2}},{{oldSupplyOrder?.billing_address?.landmark}},</p>
                      <p *ngIf="oldSupplyOrder?.billing_address?.city && oldSupplyOrder?.billing_address?.state && oldSupplyOrder?.billing_address?.country">
                        {{oldSupplyOrder?.billing_address?.city}},
                        {{oldSupplyOrder?.billing_address?.state}},
                        {{oldSupplyOrder?.billing_address?.postal_code}}
                        </p>
                      <p *ngIf="oldSupplyOrder?.billing_address?.postal_code">{{oldSupplyOrder?.billing_address?.country}}</p>

                    </div>
                  </div>
                </div>
              </div>
              <div class="column shipping_data_col" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50"
                fxFlex.xs="100" fxFlexFill>
                <div class="address_box customer_info" *ngIf="oldSupplyOrder.dental_practice">
                  <h4>Customer Info</h4>
                  <p>{{oldSupplyOrder.dental_practice.name}}</p>
                  <p>{{oldSupplyOrder.dental_practice.phone}}</p>
                  <p>{{oldSupplyOrder.dental_practice.email}}</p>
                </div>
                <div class="address_box customer_info" *ngIf="oldSupplyOrder.dental_professional">
                  <h4>Customer Info</h4>
                  <p>{{oldSupplyOrder.dental_professional.name}}</p>
                  <p>{{oldSupplyOrder.dental_professional.phone}}</p>
                  <p>{{oldSupplyOrder.dental_professional.email}}</p>
                </div>
                <div class="address_box customer_info" *ngIf="oldSupplyOrder.dental_supplier">
                  <h4>Customer Info</h4>
                  <p>{{oldSupplyOrder.dental_supplier.name}}</p>
                  <p>{{oldSupplyOrder.dental_supplier.phone}}</p>
                  <p>{{oldSupplyOrder.dental_supplier.email}}</p>
                </div>
                <div class="address_box customer_info" *ngIf="oldSupplyOrder.supplier">
                  <h4>Supplier Info</h4>
                  <p>{{oldSupplyOrder?.supplier?.business_name}}</p>
                  <p>{{oldSupplyOrder?.supplier?.phone}}</p>
                  <p>{{oldSupplyOrder?.supplier?.email}}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- MOBILE-TRACK -->
          <div class="mobile_order_track">
            <div class="order-track" [@openCloseStatus]="openStatus ? true : false">
              <div class="order-track-step" *ngFor="let singleUpdate of oldSupplyOrder.supplies_order_notes">
                <div class="order-track-status">
                  <span class="order-track-status-dot" [ngClass]="singleUpdate?.status"></span>
                  <span class="order-track-status-line"></span>
                </div>
                <div class="order-track-text">
                  <p class="order-track-text-stat">{{singleUpdate.status | titlecase}}</p>
                  <span class="order-track-text-sub">{{singleUpdate.created_at | date: 'dd-MM-yyyy hh:mm:ss'}}</span>
                </div>
              </div>
            </div>
            <div class="view_all_status" *ngIf="oldSupplyOrder.supplies_order_notes.length >= 3">
              <a (click)="filterToggleStatus()">View all status</a>
            </div>
          </div>
        </div>
        <!-- ORDER-ITEM-LIST -->
        <div class="order_items_listing order-product-listing">
          <ul>
            <li *ngFor="let singleOrderItem of oldSupplyOrder.supplies_order_items">
              <div class="cart_box_li">
                <div class="media">
                  <div class="media-left">
                    <img [src]="singleOrderItem?.supply_variant?.image?.url" class="media-object">
                    <span class="cancelled_chip" *ngIf="singleOrderItem.status === 'CANCELLED'">
                      <a> ITEM <br>
                        CANCELLED</a> </span>
                  </div>
                  <div class="media-body">
                    <!-- <h4 class="media-heading"> {{singleOrderItem.supply.name}}
                    </h4> -->
                    <div class="media-heading">
                      <div class="order_meida_flexleft">
                       <p class="product___title">{{singleOrderItem.supply.name}}</p>
                       <div class="custom_form_group">
                        <label for="" class="custom_label primary">Variant <span class="dots">:</span></label>
                        <p class="value">{{singleOrderItem.supply_variant.title}}</p>
                      </div>
                      <div class="custom_form_group">
                        <label for="" class="custom_label primary">Quantity <span class="dots">:</span> </label>
                        <p class="value">{{singleOrderItem.quantity}}</p>
                      </div>
                      <div class="custom_form_group" *ngIf="singleOrderItem.supply_variant.color">
                        <label for="" class="custom_label primary">Color <span class="dots">:</span> </label>
                        <p class="value">
                          <span class="colorBox"
                            [ngStyle]="{'background-color': singleOrderItem.supply_variant.color, 'border-color': singleOrderItem.supply_variant.color }">
                          </span>
                        </p>
                      </div>
                       </div>
                      <div class="price">
                       <p class="price_overall new_price">AUD AUD {{singleOrderItem.supply_variant.selling_price.toFixed(2)}}</p>
                       <p class="old_price"><del>AUD {{singleOrderItem.supply_variant.actual_price.toFixed(2)}}</del></p>
                       <div class="order_btn_flex">
                        <button class="btn btn-sm global-btn cancel_btn" mat-button
                          (click)="cancelOrderOrderItemDialog(singleOrderItem.id)" *ngIf="oldSupplyOrder.status === 'PENDING' && singleOrderItem.status === 'PENDING' &&
                        oldSupplyOrder.supplies_order_items.length > 1">
                          Cancel
                        </button>
                        <button class="btn btn-sm global-btn review_btn" mat-button
                          (click)="sendRatingReviewDialog(singleOrderItem)"
                          *ngIf="oldSupplyOrder.status === 'DELIVERED' && !singleOrderItem.supply_variant?.supply_reviews_aggregate?.aggregate?.count">Review</button>
                      </div>
                     </div>
                     </div>

                  </div>
                </div>
                <!-- <div class="price">
                  <p class="new_price">AUD {{singleOrderItem.supply_variant.selling_price.toFixed(2)}}</p>
                  <p class="old_price"><del>AUD {{singleOrderItem.supply_variant.actual_price.toFixed(2)}}</del></p>
                  <div class="order_btn_flex">
                    <button class="btn btn-sm global-btn cancel_btn" mat-button
                      (click)="cancelOrderOrderItemDialog(singleOrderItem.id)" *ngIf="oldSupplyOrder.status === 'PENDING' && singleOrderItem.status === 'PENDING' &&
                    oldSupplyOrder.supplies_order_items.length > 1">
                      Cancel
                    </button>
                    <button class="btn btn-sm global-btn review_btn" mat-button
                      (click)="sendRatingReviewDialog(singleOrderItem)"
                      *ngIf="oldSupplyOrder.status === 'DELIVERED' && !singleOrderItem.supply_variant?.supply_reviews_aggregate?.aggregate?.count">Review</button>
                  </div>
                </div> -->
              </div>
              <div *ngIf="singleOrderItem.supply_deal">
                <h4 class="custom_sub_heading mb-10">Deal Details</h4>
                <div class="cart_box_li deals_box_li">
                  <div class="product_deals_box">
                    <div class="media">
                      <div class="media-left">
                        <img [src]="singleOrderItem?.supply_deal?.image?.url" class="">
                      </div>
                      <div class="media-body">
                        <h4>
                          <span>
                            {{singleOrderItem.supply.name}}
                          </span>
                          <div class="deal_apply_box">
                            <div class="deal_apply_flex" *ngIf="singleOrderItem.supply_deal.type === 'GIVEAWAY'">
                              <p class="deal_accepted">
                                <i class="material-icons">task_alt</i> Deal Applied</p>
                            </div>
                            <div class="free_box" *ngIf="singleOrderItem.supply_deal.type === 'GET_BUY'"> Free </div>
                          </div>
                        </h4>
                        <div class="view_buy_get_box" *ngIf="singleOrderItem.supply_deal.type === 'GET_BUY'">
                          <div class="custom_form_group">
                            <label for="" class="custom_label">Quantity <span class="dots">:</span></label>
                            <p class="value">{{singleOrderItem.free_quantity}}</p>
                          </div>
                          <div class="custom_form_group">
                            <label for="" class="custom_label">Price <span class="dots">:</span></label>
                            <p class="value">Free</p>
                          </div>
                          <div class="custom_form_group" *ngIf="singleOrderItem.supply_variant.color">
                            <label for="" class="custom_label">Color <span class="dots">:</span> </label>
                            <p class="value">
                              <span class="colorBox"
                                [ngStyle]="{'background-color': singleOrderItem.supply_variant.color, 'border-color': singleOrderItem.supply_variant.color }">
                              </span>
                            </p>
                          </div>
                        </div>
                        <div class="view_give_way_box" *ngIf="singleOrderItem.supply_deal.type === 'GIVEAWAY'">
                          <div class="custom_form_group">
                            <label for="" class="custom_label">Type <span class="dots">:</span> </label>
                            <p class="value">{{singleOrderItem?.supply_deal?.type}}</p>
                          </div>
                          <div class="custom_form_group" *ngIf="singleOrderItem.supply_deal.type === 'GIVEAWAY'">
                            <label for="" class="custom_label">Price <span class="dots">:</span> </label>
                            <p class="value"> {{singleOrderItem?.supply_deal?.price}} </p>
                          </div>
                          <div class="deals_content_show" [@readCloseStatus]="readStatus ? true : false">
                            <p>{{singleOrderItem?.supply_deal?.description}} </p>
                          </div>
                          <div fxLayout="column" fxLayoutAlign="end end" class="read__more">
                            <a (click)="readToggleStatus()">Read more</a></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="column order_one" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="30" fxFlex.xs="100"
      fxFlexFill>
      <div class="order_details_right">
        <div class="total-cost-box">
          <div class="total-cost">
            <span class="total-text">Subtotal</span>
            <span class="total-price">
              AUD {{oldSupplyOrder.sub_total.toFixed(2)}}
            </span>
          </div>
          <div class="total-cost">
            <span class="total-text">Discount</span>
            <span class="total-price">
              (-) AUD {{oldSupplyOrder.coupon_discount.toFixed(2)}}
            </span>
          </div>
          <div class="total-cost">
            <span class="total-text"> Freight Charges </span>
            <span class="total-price">
              AUD {{oldSupplyOrder.delivery_charge.toFixed(2)}}
            </span>
          </div>
          <div class="total-cost">
            <span class="total-text">GST({{oldSupplyOrder.tax_percentage}}%)</span>
            <span class="total-price">
              AUD {{oldSupplyOrder.tax_amount.toFixed(2)}}
            </span>
          </div>
          <div class="total-cost">
            <span class="total-text">Total Amount</span>
            <span class="total-price">
              AUD {{oldSupplyOrder.total_amount.toFixed(2)}}
            </span>
          </div>
          <div class="support_btns">
            <button class="btn btn-sm global-btn cancel_btn" mat-button (click)="cancelOrder()"
              *ngIf="oldSupplyOrder.status === 'PENDING'">Cancel Order</button>
            <button class="btn btn-sm global-btn support_btn" mat-button (click)="supportRequestDialog()">
              Support</button>
            <button type="button" class="btn btn-sm global-btn support_btn" mat-button
              *ngIf="oldSupplyOrder.status ==='DELIVERED'" (click)="viewInvoice()"> View Invoice </button>
          </div>
        </div>
      </div>
      <div class="delivery_notes mt-20">
        <div class="head">
          <h4>Delivery Note</h4>
        </div>
        <ul>
          <li *ngFor="let singleNote of oldSupplyOrder?.supplies_order_notes">
            <div class="notes_content">
              <p>{{singleNote.message}} </p>
              <p *ngIf="singleNote?.extra?.tracking_number">Tracking Number: {{singleNote?.extra?.tracking_number}} </p>
              <p *ngIf="singleNote?.extra?.freight_company_name">{{singleNote?.extra?.freight_company_name}} </p>
              <div class="flex_btns_track">
                <p *ngIf="singleNote?.extra?.invoice?.url">
                  <a target="_blank" [href]="singleNote?.extra?.invoice?.url">View
                    and Download Invoice </a>
                </p>
                <p *ngIf="singleNote?.extra?.tracking_link">
                  <a target="_blank" [href]="singleNote?.extra?.tracking_link">Track </a>
                </p>
              </div>
            </div>
            <p class="status">Status : {{singleNote.created_at |date: 'dd-MM-yyyy hh:mm:ss' }}, {{singleNote.status}}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
